<!-- 个人中心 -->
<template>
  <div class="person-center">
    <div class="page-header">
      <h2 class="page-title">个人中心</h2>
      <p class="page-subtitle">Personal Center</p>
    </div>

    <div class="content-wrapper">
      <el-card class="info-card" shadow="hover">
        <div slot="header" class="card-header">
          <div class="header-content">
            <i class="el-icon-user-solid avatar-icon"></i>
            <div class="header-text">
              <h3>账户信息</h3>
              <span class="subtitle">Account Information</span>
            </div>
          </div>
        </div>

        <div class="info-list">
          <div class="info-item">
            <div class="info-label">
              <i class="el-icon-user"></i>
              <span>账号</span>
            </div>
            <div class="info-value">{{ userInfo.username }}</div>
            <div class="info-note">(可联系管理员修改)</div>
          </div>

          <div class="info-item">
            <div class="info-label">
              <i class="el-icon-lock"></i>
              <span>密码</span>
            </div>
            <div class="info-value">••••••••</div>
            <div class="info-note">(已加密)</div>
          </div>

          <div class="info-item">
            <div class="info-label">
              <i class="el-icon-mobile-phone"></i>
              <span>手机号</span>
            </div>
            <div class="info-value">{{ userInfo.phone_number ? userInfo.phone_number : '暂无' }}</div>
          </div>

          <div class="info-item">
            <div class="info-label">
              <i class="el-icon-date"></i>
              <span>创建日期</span>
            </div>
            <div class="info-value">{{ userInfo.create_time }}</div>
          </div>

          <div class="info-item">
            <div class="info-label">
              <i class="el-icon-time"></i>
              <span>最近登录</span>
            </div>
            <div class="info-value">{{ userInfo.last_login_time }}</div>
          </div>
        </div>

        <div class="action-buttons">
          <el-button
            class="custom-button"
            icon="el-icon-edit"
            @click="dialogVisible = true"
            v-waves
          >修改密码</el-button>
        </div>
      </el-card>
    </div>

    <!-- 抽屉式弹窗 -->
    <el-drawer
      :title="dialogName"
      :visible.sync="dialogVisible"
      direction="rtl"
      size="450px"
      :close-on-press-escape="false"
    >
      <div class="drawer-content">
        <el-form ref="form" :model="dialogForm" label-width="100px" class="drawer-form">
          <el-form-item label="原密码" required>
            <el-input
              clearable
              v-model="dialogForm.oldPassword"
              type="password"
              show-password
              placeholder="请输入原密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="修改密码" required>
            <el-input
              clearable
              v-model="dialogForm.password"
              type="password"
              show-password
              placeholder="输入密码自动md5加密"
            ></el-input>
          </el-form-item>
        </el-form>

        <div class="drawer-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button class="custom-button" @click="save" v-waves>确 定</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  updatePasswordApi,
  loginOutApi
} from "@/services/systemPage/admin_user.js";
// import md5 from "md5";
export default {
  components: {},
  async created() {
    // console.log(this.userInfo);
  },
  // directives: {
  //   waves,
  // },
  data() {
    return {
      loading: false,
      /* 弹窗 */
      dialogName: "修改密码",
      dialogVisible: false,
      dialogForm: {}
    };
  },
  computed: {
    ...mapState(["userInfo"])
  },
  watch: {},
  methods: {
    /* 保存 */
    save() {
      if (!this.dialogForm.oldPassword || !this.dialogForm.password) {
        this.$message.error("请填写必填字段");
        return;
      }
      this.$confirm("此操作将覆盖之前的密码, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const result = await updatePasswordApi({
            ...this.userInfo,
            password: this.dialogForm.password,
            oldPassword: this.dialogForm.oldPassword
          });

          if (result.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功!"
            });
            this.dialogVisible = false;
            setTimeout(() => {
              loginOutApi().then(resp => {
                if (resp.code == 200) {
                  this.$message({
                    type: "success",
                    message: "已安全退出账户!"
                  });
                }
                this.$router.push({ name: "Login" });
              });
            }, 800);
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="less">
.person-center {
  width: 100%;
  min-height: 100vh;
  background: #f5f7fa;
  padding: 30px;
}

.page-header {
  margin-bottom: 30px;

  .page-title {
    font-size: 28px;
    font-weight: 600;
    color: #73ae52;
    margin: 0 0 8px 0;
  }

  .page-subtitle {
    font-size: 14px;
    color: #909399;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
}

.content-wrapper {
  max-width: 800px;
}

.info-card {
  border-radius: 12px;
  overflow: hidden;
  border: none;

  /deep/ .el-card__header {
    background: linear-gradient(135deg, #73ae52 0%, #5a9141 100%);
    padding: 24px 30px;
    border: none;
  }

  /deep/ .el-card__body {
    padding: 0;
  }
}

.card-header {
  .header-content {
    display: flex;
    align-items: center;
    gap: 16px;

    .avatar-icon {
      width: 56px;
      height: 56px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
      color: #fff;
    }

    .header-text {
      h3 {
        margin: 0 0 4px 0;
        font-size: 20px;
        font-weight: 600;
        color: #fff;
      }

      .subtitle {
        font-size: 13px;
        color: rgba(255, 255, 255, 0.8);
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
    }
  }
}

.info-list {
  padding: 30px;
}

.info-item {
  display: flex;
  align-items: center;
  padding: 18px 20px;
  margin-bottom: 12px;
  background: #f9fafb;
  border-radius: 8px;
  transition: all 0.3s ease;
  border-left: 3px solid transparent;

  &:hover {
    background: #f0f9eb;
    border-left-color: #73ae52;
    transform: translateX(4px);
  }

  &:last-child {
    margin-bottom: 0;
  }

  .info-label {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 120px;
    font-weight: 500;
    color: #606266;

    i {
      font-size: 18px;
      color: #73ae52;
    }

    span {
      font-size: 15px;
    }
  }

  .info-value {
    flex: 1;
    color: #303133;
    font-size: 15px;
  }

  .info-note {
    color: #909399;
    font-size: 13px;
    margin-left: 8px;
  }
}

.action-buttons {
  padding: 20px 30px 30px;
  display: flex;
  justify-content: center;

  .custom-button {
    background: #73ae52;
    color: #fff;
    border: none;
    padding: 12px 32px;
    font-size: 15px;
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
      background: #5a9141;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(115, 174, 82, 0.3);
    }

    &:active {
      transform: translateY(0);
    }
  }
}

// 抽屉样式
/deep/ .el-drawer__header {
  margin-bottom: 24px;
  padding: 24px 30px;
  border-bottom: 2px solid #73ae52;

  > span {
    font-size: 20px;
    font-weight: 600;
    color: #73ae52;
  }
}

/deep/ .el-drawer__body {
  padding: 0;
}

.drawer-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.drawer-form {
  flex: 1;
  padding: 30px;

  /deep/ .el-form-item__label {
    font-weight: 500;
    color: #606266;
  }

  /deep/ .el-input__inner {
    border-radius: 6px;
    border-color: #dcdfe6;

    &:focus {
      border-color: #73ae52;
    }
  }

  /deep/ .el-form-item.is-required .el-form-item__label::before {
    color: #73ae52;
  }
}

.drawer-footer {
  padding: 20px 30px;
  border-top: 1px solid #ebeef5;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background: #fff;

  .el-button {
    padding: 10px 24px;
    border-radius: 6px;
  }

  .custom-button {
    background: #73ae52;
    color: #fff;
    border: none;

    &:hover {
      background: #5a9141;
    }
  }
}

// 响应式设计
@media screen and (max-width: 768px) {
  .person-center {
    padding: 20px 15px;
  }

  .info-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;

    .info-label {
      min-width: auto;
    }
  }

  /deep/ .el-drawer {
    width: 90% !important;
  }
}
</style>
